const getIsSignUpSite = () => {
  const hostName = window.location.hostname;
  return hostName === window.baseAppConfig.signUpSiteHostName;
};

export default getIsSignUpSite;
